export default {
  APP_NAME: "Studio Floristic",
};
